import GameScene from "../scenes/GameScene";
import { GameObject } from "./GameObject";

export class Goal extends GameObject {
	enabled = true;

	poles: GameObject[];
	constructor(scene: GameScene, x: number, y: number) {
		super(scene);
		this.x = x;
		this.y = y;
		this.poles = [];
		scene.physics.world.enableBody(this, Phaser.Physics.Arcade.STATIC_BODY);
		const body = this.body as Phaser.Physics.Arcade.StaticBody;
		body.setSize(50, 500, false);
		const dx = -(body.position.x - this.x);
		const dy = -(body.position.y - this.y);
		body.setOffset(dx - body.width / 2, dy - body.height / 2);
		const finishLine = new GameObject(this.scene);
		finishLine.addImage("finishLine");
		finishLine.setPosition(x, y - 10);
		for (let i = 0; i < 2; i++) {
			const pole = new GameObject(this.scene);
			const poleImg = pole.addImage("finishFlag");
			poleImg.setOrigin(0.5, 1);
			// poleImg.setDisplaySize(10, 160);
			if (i == 0) pole.setPosition(x + 30, y - 200);
			else pole.setPosition(x - 30, y + 270);
			this.scene.addObject(pole, "game");
			this.poles.push(pole);
		}

		const p1 = this.poles[0];
		const p2 = this.poles[1];
		//finishLineImg.setAngle(Phaser.Math.Angle.Between(p1.x, p1.y, p2.x, p2.y));
		finishLine.setAngle(this.getAngle(p1, p2));

		const cheerleader = new GameObject(this.scene);
		cheerleader.addImage("finishCheers");
		cheerleader.setPosition(p1.x - 140, p1.y - 100);
		this.scene.addObject(cheerleader, "game");

		this.scene.addObject(finishLine, "bg");
	}

	getAngle(obj1: GameObject, obj2: GameObject): number {
		let angle = (Math.atan2(obj2.y - obj1.y, obj2.x - obj1.x) * 180) / Math.PI;
		angle += 90;
		return angle;
	}

	onHit(): void {
		this.enabled = false;
	}
}
